<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="talkview compare-face-box"
  >
    <ul class="compare-face-ul">
      <li>
        <p>考生认证照片</p>
        <img v-if="photoUrl" :src="photoUrl" />
      </li>
      <li>
        <p>考生截图照片</p>
        <img v-if="screenshotUrl" :src="screenshotUrl" />
      </li>
    </ul>
    <h4>身份信息对比结果：{{ loading ? '计算中' : errMsg ?  '人脸比对失败' : similarityScore + '分' }}</h4>
  </div>
</template>

<script>
export default {
  name: "compareface",
  data() {
    return {
      loading: false,
      photoUrl: "",
      screenshotUrl: "",
      similarityScore: 0,
      errMsg: '',
    };
  },
  async created() {
    this.getImgs();
    this.onWebConnect()
  },
  methods: {
    onWebConnect() {
      const _this = this;
      if (window.core) {
        const connectTalkWindowUpdated = function (isOpen) {
          _this.onHandleTalkWindowUpdated(isOpen)
        }
        // 订阅原生事件
        // 推巡检音频流成功
        window.core.talkWindowUpdated.connect(connectTalkWindowUpdated)
        this.$once("hook:beforeDestroy", () => {
          // 销毁页面后取消订阅，避免多次订阅
          window.core.talkWindowUpdated.disconnect(connectTalkWindowUpdated)
        });
      } else {
        setTimeout(() => {
          _this.onWebConnect()
        }, 1000)
      }
    },
    onHandleTalkWindowUpdated(isOpen) {
      if (isOpen) {
        this.getImgs()
      } else {
      }
    },
    async getImgs() {
      // const { screenshotUrl } = this.$utils.$localStorage.get("compareExamineeFace")
      // this.similarityScore = 99;
      // this.screenshotUrl = await this.$HTTP.ApiOss.signatureUrl(screenshotUrl);
      // this.photoUrl = await this.$HTTP.ApiOss.signatureUrl(
      //   'IDCard/ZegoTestTStuwlltsdw5tio998yuuESgptd_rp_self_portrait_20230316111752.jpg'
      // );
      this.loading = false
      this.errMsg = ''
      this.similarityScore = 0
      this.screenshotUrl = ''
      this.photoUrl = ''
      const { examId, screenshotUrl } = this.$utils.$localStorage.get("compareExamineeFace")
      const { examType } = this.$utils.$localStorage.get("userInfo");
      this.loading = true
      try {
        const res = await this.$HTTP.ApiLogin.POSTcompareExamineePhoto({
          examId,
          screenshotUrl,
          examType
        });
        this.similarityScore = Math.round(res.similarityScore);
        this.errMsg = res.errMsg
        this.screenshotUrl = await this.$HTTP.ApiOss.signatureUrl(screenshotUrl);
        this.photoUrl = await this.$HTTP.ApiOss.signatureUrl(
          res.describeVerifyResult
        );
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.talkview {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  word-break: break-all;
  overflow: hidden;
  padding-top: 20px;
}
.compare-face-box h4,
.compare-face-box ul,
.compare-face-box li {
  padding: 0;
  margin: 0;
}
.compare-face-box h4 {
  text-align: center;
  margin-top: 20px;
  font-size: 20px;
}
.compare-face-box li {
  list-style: none;
}
.compare-face-ul {
  margin-top: 10px !important;
  display: flex;
  justify-content: space-between;
}
.compare-face-ul li {
  flex: 1;
  text-align: center;
}
.compare-face-ul p {
  margin: 10px 0;
  padding: 7px 0;
  background: #ebeef5;
  color: #606266;
  font-weight: bold;
}
.compare-face-ul img {
  display: block;
  margin: 0 auto;
  width: 95%;
  height: 300px;
  object-fit: contain;
}
</style>
